import React, { Component } from 'react';
import { connect } from 'react-redux';

import Container from 'react-bootstrap/Container';
import Row from 'react-bootstrap/Row';
import Col from 'react-bootstrap/Col';
import Button from 'react-bootstrap/Button';
import Card from 'react-bootstrap/Card';

import { updateUserNotification } from "../../store/actions/userActions"

import './UserInfoProfile.css'

class EmailPrefs extends Component {
  state = {};

  render() {
    const { auth, profile } = this.props
    
    if (profile.isLoaded) {
      return (
        <Card className="ProfileCard">
          <Card.Header as="h5">Email Preferences</Card.Header>
          <Card.Body>
            <Container>
              <Row className="ButtonLine">
                <Col xs={8} style={{paddingLeft: 0}}> <p>When New Projects are Announced</p> </Col>

                <Col xs={4}>
                  {!!profile.notifications.email.newProjects && (
                    <Button onClick={() => this.props.updateUserNotification(auth.uid, "email", "newProjects", false)} className="BooleanButton" size="sm" variant="danger">Turn Off</Button>
                  )}

                  {!profile.notifications.email.newProjects && (
                    <Button onClick={() => this.props.updateUserNotification(auth.uid, "email", "newProjects", true)} className="BooleanButton" size="sm" variant="primary">Turn On</Button>
                  )}
                </Col>
              </Row>

              <Row className="ButtonLine">
                <Col xs={8} style={{paddingLeft: 0}}> <p>When Confirmed for a Project</p> </Col>

                <Col xs={4}>
                  {!!profile.notifications.email.confirmedForProject && (
                    <Button onClick={() => this.props.updateUserNotification(auth.uid, "email", "confirmedForProject", false)} className="BooleanButton" size="sm" variant="danger">Turn Off</Button>
                  )}

                  {!profile.notifications.email.confirmedForProject && (
                    <Button onClick={() => this.props.updateUserNotification(auth.uid, "email", "confirmedForProject", true)} className="BooleanButton" size="sm" variant="primary">Turn On</Button>
                  )}
                </Col>
              </Row>

              <Row className="ButtonLine">
                <Col xs={8} style={{paddingLeft: 0}}> <p>When a Confirmed Project is Updated</p> </Col>

                <Col xs={4}>
                  {!!profile.notifications.email.projectUpdated && (
                    <Button onClick={() => this.props.updateUserNotification(auth.uid, "email", "projectUpdated", false)} className="BooleanButton" size="sm" variant="danger">Turn Off</Button>
                  )}

                  {!profile.notifications.email.projectUpdated && (
                    <Button onClick={() => this.props.updateUserNotification(auth.uid, "email", "projectUpdated", true)} className="BooleanButton" size="sm" variant="primary">Turn On</Button>
                  )}
                </Col>
              </Row>

              <Row className="ButtonLine">
                <Col xs={8} style={{paddingLeft: 0}}> <p>When a Supervisor Comments on a Project</p> </Col>

                <Col xs={4}>
                  {!!profile.notifications.email.supervisorComment && (
                    <Button onClick={() => this.props.updateUserNotification(auth.uid, "email", "supervisorComment", false)} className="BooleanButton" size="sm" variant="danger">Turn Off</Button>
                  )}

                  {!profile.notifications.email.supervisorComment && (
                    <Button onClick={() => this.props.updateUserNotification(auth.uid, "email", "supervisorComment", true)} className="BooleanButton" size="sm" variant="primary">Turn On</Button>
                  )}
                </Col>
              </Row>

              <Row className="ButtonLine">
                <Col xs={8} style={{paddingLeft: 0}}> <p>When a Lead Comments on a Project</p> </Col>

                <Col xs={4}>
                  {!!profile.notifications.email.leadComment && (
                    <Button onClick={() => this.props.updateUserNotification(auth.uid, "email", "leadComment", false)} className="BooleanButton" size="sm" variant="danger">Turn Off</Button>
                  )}

                  {!profile.notifications.email.leadComment && (
                    <Button onClick={() => this.props.updateUserNotification(auth.uid, "email", "leadComment", true)} className="BooleanButton" size="sm" variant="primary">Turn On</Button>
                  )}
                </Col>
              </Row>
            </Container>
          </Card.Body>
        </Card>
      )
    } else {
      return(
        <div>Loading...</div>
      )
    }
  }
}

const mapDispatchToProps = (dispatch) => {
  return {
    updateUserNotification: (userID, medium, type, value) => dispatch(updateUserNotification(userID, medium, type, value)),
  }
}

export default connect(null, mapDispatchToProps)(EmailPrefs);